<template lang="pug">
liondesk-dialog(
:value="value"
dialog-title="Import Contacts"
:hide-cancel-button="true"
:dialog-body-html="true"
@click:ok="closeDialog"
)
  template(v-if="step === 1" slot="body")
    p When uploading the import file, please note that:
    ul
      li.mb-3
        b Supported file format:
        |  CSV.
      li.mb-3
        b Maximum file size:
        |  200MB.
      li.mb-3
        b Recommended contact rows:
        |  maximum 10,000 per file
      li.mb-3
        b Limited to 5 imports per day.
    span Uploading larger files may take longer. Optimize your file size for faster processing.
  template(v-if="step === 2" slot="body")
    p When importing contacts, please note that:
    ul
      li.mb-3 The selected tags are assigned to every contact.
      li.mb-3 You should map at least one header.
      li.mb-3
        | Use the option
        i  Add a custom field... 
        | to create a custom field.
</template>

<script>
import LiondeskDialog from '@/Core/components/LiondeskDialog';

export default {
    name: 'import-help-dialogs',
    components: {
      LiondeskDialog,
    },
    props: {
      step: {
        type: Number,
        default: 1,
      },
      value: Boolean,
    },
    methods: {
        closeDialog() {
            this.$emit('input', false);
        },
    },
}
</script>